import React from "react";
import EmptyState from "./EmptyState";
import { useDraftData } from "../../context/DraftDataContext";

interface TeamDataUnavailableProps {
  /** What the surface would show — e.g. "Stacking", "Team analysis". */
  feature?: string;
  /** Compact variant for inside table/card bodies. */
  dense?: boolean;
}

/**
 * Single, consistent notice shown in place of any team-dependent surface
 * (stacks, archetypes, team filter, team pages) when the loaded import lacks
 * team data — typically a DraftKings sync whose team fetch failed. Renders one
 * explanatory line instead of an empty list or blank card.
 */
export default function TeamDataUnavailable({ feature = "Stacking and team analysis", dense = false }: TeamDataUnavailableProps) {
  const { provider } = useDraftData();
  const sourceLabel =
    provider === "DraftKings" ? "this DraftKings import" :
    provider === "Underdog" ? "this import" :
    "this import";
  return (
    <EmptyState
      dense={dense}
      title={`${feature} unavailable`}
      hint={`${feature} needs team data, which isn't available for ${sourceLabel}. Everything else (exposure, ADP, and combos) still works.`}
    />
  );
}
